export enum CustomsRelationshipEnum {
    RELATED = 'RELATED',
    NOT_RELATED = 'NOT_RELATED'
}
